var React = require('react');

function ArrowRightControlled (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"product-image-scroll-right","d":"M22.423,20.183,11.834,9.6a1.991,1.991,0,0,1,0-2.824,2.017,2.017,0,0,1,2.833,0l12,11.989a2,2,0,0,1,.058,2.758L14.675,33.6a2,2,0,0,1-2.833-2.824Z","transform":"translate(-11.246 -6.196)","fill":"currentColor"}));
}

ArrowRightControlled.defaultProps = {"width":"16","height":"27.984","viewBox":"0 0 16 27.984"};

module.exports = ArrowRightControlled;

ArrowRightControlled.default = ArrowRightControlled;
